/**
 * NotificationCampaignRankingItem
 *
 * campaignRanking — `notification_campaign_ranking_item.dart:21-85`.
 * Leading: `campaign.png` icon tinted with the exclusive color (no avatar /
 * user tap). Title `{title} campaign ended`. Subtitle embeds the 1st/2nd/3rd
 * rank ordinal then ` - {date}`. No trailing thumbnail.
 */
import React from 'react';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { useDateFormatters } from '@/presentation/utils/useDateFormatters';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { NotificationRowLayout } from '../NotificationRowLayout';
import { NotificationLeadingIcon } from './shared/NotificationLeadingIcon';
import type { NotificationItemProps } from './notificationItemProps';

export const NotificationCampaignRankingItem: React.FC<NotificationItemProps> = ({
  notification,
  onItemTap,
}) => {
  const { l10n } = useLocale();
  const { formatDate } = useDateFormatters();
  const { theme } = useTheme();
  const n = l10n.inbox.notifications;

  const { info } = notification;
  const campaign = info.campaignInfo;
  const ranking = campaign?.ranking ?? 0;

  // Flutter ordinal: 1 → 1st, 2 → 2nd, else → 3rd.
  const rankText = ranking === 1 ? n.rank1st : ranking === 2 ? n.rank2nd : n.rank3rd;

  const title = n.campaignEnded.replace('{title}', campaign?.campaignTitle ?? '');
  const subtitle = `${n.campaignRankingSubtitle.replace('{rank}', rankText)} - ${formatDate(
    info.timestamp,
  )}`;

  return (
    <NotificationRowLayout
      leading={
        <NotificationLeadingIcon
          iconPath="/assets/images/campaign.png"
          iconColor={theme.exclusive}
        />
      }
      title={title}
      subtitle={subtitle}
      onItemTap={onItemTap ? () => onItemTap(notification) : undefined}
    />
  );
};
